import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { Impressum } from './pages/Impressum';
import { Datenschutz } from './pages/Datenschutz';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/impressum" element={<Impressum data-id="element-5" />} data-id="element-4" />
        <Route path="/datenschutz" element={<Datenschutz data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}